import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input, Col, Row } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { FormItem } from 'utils/form_helpers';
import { Error, PhotoUpload } from 'components/common';


class SliderForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { actions, slider, siteId } = this.props;
        const instance = slider.editObject;

        let data = Object.assign({ site: siteId }, values);
        if (instance && instance.id) {
          data.id = instance.id;
        }
        if (data.bg_image) {
          data.bg_image = data.bg_image.id;
        }
        console.log(data);

        actions.sliderUpdate(data);
      }
    });
  };

  close = () => {
    const { actions } = this.props;
    actions.sliderShowEditForm({ show: false });
  };

  render() {
    const { form, slider } = this.props;
    const { showEditForm, updateStatus, editObject } = slider;
    const instance = editObject;

    const error = updateStatus.error || {};
    const errorData = error.data || {};

    const isLoading = slider.updateStatus.isLoading;

    return (
      <Modal
        width={640}
        visible={showEditForm}
        title="Редактирование слайда"
        onCancel={this.close}
        maskClosable={false}
        footer={[
          <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
            Сохранить
          </Button>,
        ]}
      >
        <Spin spinning={isLoading}>
          <Form onSubmit={this.handleSubmit}>
            <Error errors={errorData.non_field_errors}/>

            <Row gutter={32}>
              <Col span={17}>
                <div className="form-block">
                  <FormItem
                    form={form}
                    instance={instance}
                    name="position"
                    label="Позиция"
                    required={true}
                    errorData={errorData}
                  >
                    <Input size="large" style={{ width: '100%' }}/>
                  </FormItem>

                  <FormItem
                    form={form}
                    instance={instance}
                    name="text"
                    label="Текст"
                    required={false}
                    errorData={errorData}
                  >
                    <Input.TextArea size="large" autosize={{ minRows: 3 }}/>
                  </FormItem>
                </div>
              </Col>

              <Col span={7}>
                <FormItem
                  form={form}
                  instance={instance}
                  name="bg_image"
                  label="Картинка"
                  required={true}
                  errorData={errorData}
                  valuePropName="fileList"
                >
                  <PhotoUpload
                    mode="single"
                    title="Загрузить картинку"
                  />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

const WrappedForm = Form.create()(SliderForm);

function mapStateToProps(state) {
  return {
    slider: state.slider,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.slider), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedForm);

